import React from 'react';
import { WalletDetectionDebug } from '../debug/WalletDetectionDebug';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth0 } from '../context/Auth0Context';
import LoginPage from './LoginPage';
import MultiSigUIContainer from '../MultiSigUIContainer';
import SessionTimeoutDialog from './SessionTimeoutDialog';
import Footer from '../common/Footer';
import ErrorBoundary from '../ErrorBoundary';
import Auth0ServiceIntegration from '../Auth0ServiceIntegration';

const AuthenticatedApp: React.FC = () => {
    const { isAuthenticated, isLoading } = useAuth0();

    // Show loading state while Auth0 is initializing
    if (isLoading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                }}
            >
                <CircularProgress size={40} />
                <Typography variant="h6" sx={{ mt: 2 }}>
                    Initializing authentication...
                </Typography>
            </Box>
        );
    }

    // If not authenticated, show login page
    if (!isAuthenticated) {
        return <LoginPage />;
    }

    // If authenticated, show the main application with footer and session timeout dialog
    return (
        <ErrorBoundary>
            <Auth0ServiceIntegration />
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                height: 'fit-content'
            }}>
                <Box sx={{ flex: '1 0 auto' }}>
                    <MultiSigUIContainer />
                </Box>
                <Box sx={{ flexShrink: 0 }}>
                    <Footer />
                </Box>
                <SessionTimeoutDialog timeoutMinutes={15} warningMinutes={2} />
            </Box>
        </ErrorBoundary>
    );
};

export default AuthenticatedApp;
